import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import {Table, Space, Select, Button, Modal, Row, Col, Form, DatePicker, Input} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined, CheckCircleOutlined, EyeOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import moment from "moment";
import 'quill/dist/quill.snow.css';
import { UsePostRequest } from "../../utils/api/ApiRequests";
import {
  // GetAllBranches,
  // GetAllBusinessUnits,
  // GetAllDepartments,
  GetAllEmploymentStatus,
  GetAllPositions,
  GetAllProjects,
} from "../../utils/api/DropdownFiltersApi";
import { usePostRequest } from "../../hooks/usePostRequest";
import ReactQuillEditor from "../../components/ReactQuillEditor/ReactQuillEditor";
import { capitalizeEachWord, getIsAdminLogin } from "../../utils/Common";


const AddSubmitButton = ({ form, isLoading }) => {
  const [submittable, setSubmittable] = useState(false);
  const values = Form.useWatch([], form);
  React.useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values]);

  return (
    <Button
      type="primary"
      htmlType="submit"
      disabled={!submittable}
      loading={isLoading}
    >
      Submit
    </Button>
  );
};

const {Option} = Select;

export default function Memorandum() {
  const [form] = Form.useForm();
  const isAdminLogin = getIsAdminLogin();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [clickedRowData, setClickedRowData] = useState({});
  const [modal, contextHolder] = Modal.useModal();
  const statusOptions = GetAllEmploymentStatus();
  const positionOptions = GetAllPositions();
  const projectOptions = GetAllProjects();
  const dateFormat = "YYYY-MM-DD";
  const [searchTerm, setSearchTerm] = useState("")

  const dropdownOptions = {
    employment_status: statusOptions.slice(1),
    position: positionOptions.slice(1),
    project: projectOptions.slice(1),
  };

  const { callPost, isLoading } = usePostRequest(() => {
    setShowAddModal(false);
    setShowEditModal(false);
    setShowViewModal(false);
    resetValues();
    setFilterConfig((prev) => ({ ...prev, is_updated: !prev.is_updated }));
  });


  const [filterConfig, setFilterConfig] = useState({
    is_updated: false,
  });


  const tableColumns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Date Posted",
      dataIndex: "memo_date",
      key: "memo_date",
      render: (memo_date, record) => (
        <div>{moment(memo_date).format("MMM DD, YYYY")}</div>
      ),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Memo From",
      dataIndex: "memo_from",
      key: "memo_from",
    },
    {
      title: "Memo To",
      dataIndex: "details",
      key: "details",
      render: (details, record) => (
        <ul
          onClick={() => handleRowClick(record)}
          className="pointer-cursor custom-list"
        >
          {details.map((value, index) => (
            <li key={index}>{value.memo_to}</li>
          ))}
        </ul>
      ),
    },
    {
      title: "Prepared By",
      dataIndex: "added_by_name",
      key: "added_by_name",
      render: (data, record) => (
        <div>
          <Row>{data}</Row>
          <Row>{moment(record.added_on).format("MMM DD, YYYY hh:mm A")}</Row>
        </div>
      ),
    },
    {
      title: "Approved By",
      dataIndex: "approved_by_name",
      key: "approved_by_name",
      render: (data, record) => (
        <div>
          <Row>{data}</Row>
          <Row>{record.status==="approved"&&moment(record.approved_on).format("MMM DD, YYYY hh:mm A")}</Row>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (data) => <div>{capitalizeEachWord(data)}</div>
    },
  ];

  const onFinish = (formInputs) => {
    formInputs.memo_date = formInputs.memo_date.format(dateFormat);
    formInputs.type = formInputs.recipients.map((item) => item.type);
    formInputs.memo_to = formInputs.recipients.map((item) => item.memo_to);
    formInputs.status = "pending";
    const values = Object.entries(formInputs).map(([key, value]) => ({ key, value }));
   
    callPost(
      "memos/add",
      values,
      false
    );
  };

  const onEdit = (formInputs) => {
    formInputs.memo_date = formInputs.memo_date.format(dateFormat);
    formInputs.type = formInputs.recipients.map((item) => item.type);
    formInputs.memo_to = formInputs.recipients.map((item) => item.memo_to);
    callPost(`memos/update/`+clickedRowData.id, formInputs, false);
  };

  const confirmDelete = (memo) => {
    modal.confirm({
      title: `Are you sure you want to delete this memo"?`,
      icon: <ExclamationCircleOutlined />,
      content: "You cannot undo this action.",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => handleDelete(memo.id),
      okType: "danger",
    });
  };

  function handleDelete(passedId) {
    callPost("memos/delete", { memo_id: passedId }, false);
    resetValues();
  }

  const confirmApprove = (memo) => {
    modal.confirm({
      title: `Are you sure you want to approve this memo"?`,
      icon: <CheckCircleOutlined />,
      okText: "Approve",
      cancelText: "Cancel",
      onOk: () => handleApprove(memo.id),
    });
  };

  function handleApprove(passedId) {
    callPost("memos/approve", { memo_id: passedId, status: "approved" }, false);
    resetValues();
  }

  function resetValues () {
    form.resetFields();
    setContent("");
  }

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
    }
  };

  const handleFilter = (e, field) => {
    setFilterConfig((prev) => ({ ...prev, [field]: e }));
  };

  const handleRowClick = (rowData) => {
    if (isAdminLogin) {
      setContent(rowData.content);
      setClickedRowData(rowData);
      const formattedValues = { ...rowData };
      formattedValues.memo_date = rowData.memo_date?dayjs(rowData.memo_date, dateFormat):'';
      form.setFieldsValue(formattedValues);
      setShowViewModal(true);
    } else {
      navigate("view", {state: rowData})
    }
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

  const handleQuillChange = (html) => {
    setContent(html);
    form.setFieldValue('content', html);
  }

    React.useEffect(() => {
      const searchTimeout = setTimeout(() => {
        setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
      }, 2000);
  
      return () => {
        clearTimeout(searchTimeout);
      };
    }, [searchTerm]);

  React.useEffect(() => {
    async function fetchTableData() {
      setIsFetching(true);
      setTableData([]);
      const response = await UsePostRequest("memos/get", filterConfig);
      if (response.data) {
        const res = response.data.memos.map((data) => {
          const info = data;
          info.recipients = data.details.map((rec) => {
            let recInfo = {}
            recInfo.type = rec.type;
            recInfo.memo_to = rec.memo_to_id;
            return recInfo;
          });
          return info;
        })
        setTableData(res);
      }
      setIsFetching(false);
    }

    fetchTableData();
  }, [filterConfig]);

  return (
    <Navbar
    activeNav="memo"
      pageTitle="Memorandums"
      pageButtonTitle="Add Memo"
      onClickButton={() => {
        setShowAddModal(true);
        setShowViewModal(false);
      }}
      setSearchQuery={(e) => setSearchTerm(e)}
      onSearch={handleSearch}
      searchPlaceholder="subject"
      isManager
      searchable
      noButton={!isAdminLogin}
    >
      {isAdminLogin && (
        <Space className="mt-4 justify-content-start" wrap>
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Status"
            optionFilterProp="items"
            filterOption={(input, option) =>
              (option?.label ?? "").includes(input)
            }
            filterSort={(optionA, optionB) => {
              if (optionA.label?.includes("All")) return -1;
              if (optionB.label?.includes("All")) return 1;
              return optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase());
            }}
            options={statusOptions}
            onChange={(e) => handleFilter(e, "employment_status_id")}
          />
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Position"
            optionFilterProp="items"
            filterOption={(input, option) => (option?.label?.toLowerCase().includes(input?.toLowerCase()))}
            filterSort={(optionA, optionB) => {
              if (optionA.label?.includes("All")) return -1;
              if (optionB.label?.includes("All")) return 1;
              return optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase());
            }}
            options={positionOptions}
            onChange={(e) => handleFilter(e, "position_id")}
          />
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Project"
            optionFilterProp="items"
            filterOption={(input, option) => (option?.label?.toLowerCase().includes(input?.toLowerCase()))}
            filterSort={(optionA, optionB) => {
              if (optionA.label?.includes("All")) return -1;
              if (optionB.label?.includes("All")) return 1;
              return optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase());
            }}
            options={projectOptions}
            onChange={(e) => handleFilter(e, "project_id")}
          />
        </Space>
      )}
      <Table
        className={isAdminLogin ? "" : "mt-4"}
        rowKey="id"
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching}
        onRow={(record) => ({
          ...rowProps(record),
          style: { cursor: "pointer" },
        })}
      />
      <Modal
      maskClosable={false}
        title={`${showAddModal ? "Add" : "Edit"} Memo`}
        centered
        open={showAddModal || showEditModal}
        footer={null}
        onCancel={() => {
          setShowAddModal(false);
          setShowEditModal(false);
          resetValues();
        }}
        width={800}
      >
        <Form
          className="mt-3 mx-3"
          form={form}
          name="validateOnly"
          layout="vertical"
          onFinish={showAddModal ? onFinish : onEdit}
        >
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                name="memo_date"
                label="Date Posted"
                rules={[
                  {
                    required: true
                  },
                ]}
              >
                <DatePicker  placeholder="YYYY-MM-DD"/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item
                name="memo_from"
                label="Memo From"
                rules={[
                  {
                    required: true, whitespace: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} lg={24}>
              <Form.Item
                name="subject"
                label="Subject"
                rules={[
                  {
                    required: true, whitespace: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} lg={24}>
              <Form.Item
                name="content"
                label="Content"
                rules={[
                  {
                    required: true, whitespace: true,
                  },
                ]}
              >
                <ReactQuillEditor content={content} handleQuillChange={handleQuillChange}/>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <span className="red me-1">*</span> Recipients
            <Form.List
              name="recipients"
              initialValue={[{}]}
            >
              {(fields, { add, remove }) => (
                <>
                  <Col xs={24} lg={24}>
                    {fields.map(({ key, name, fieldKey }) => (
                        <Row
                          key={key}
                          style={{ marginBottom: 0 }}
                          className="d-flex justify-content-between"
                        >
                          <Col xs={11}>
                            <Form.Item
                              name={[name, "type"]}
                              fieldKey={[fieldKey, "type"]}
                              rules={[
                                {
                                  required: true, whitespace: true,
                                  message: "Please select the recipient type",
                                },
                              ]}
                            >
                              <Select placeholder="Type" onChange={(value) => {
                                form.setFieldsValue({ [`${name}.type`]: value });
                              }}>
                                <Option value="employment_status">Employment Status</Option>
                                <Option value="position">Position</Option>
                                <Option value="project">Project</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={11}>
                            <Form.Item
                              name={[name, "memo_to"]}
                              fieldKey={[fieldKey, "memo_to"]}
                              rules={[
                                {
                                  required: true, whitespace: true,
                                  message: "Please select the memo to",
                                },
                              ]}
                            >
                              <Select placeholder="Memo To" options={dropdownOptions[form.getFieldValue(["recipients", name, "type"])]}/>
                            </Form.Item>
                          </Col>
                          <Col xs={2}>
                            <Button
                              onClick={() => {
                                remove(name);
                              }}
                              icon={<DeleteOutlined />}
                              disabled={fields.length===1}
                            />
                          </Col>
                        </Row>
                      ))}
                  </Col>
                  <Row>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusCircleOutlined />}
                    >
                      Add Recipient
                    </Button>
                  </Row>
                </>
              )}
            </Form.List>
          </Row>

          <Form.Item>
            <Row className="d-flex justify-content-end">
              <Row>
                <Button
                  className="me-2"
                  danger
                  onClick={() => {
                    setShowAddModal(false);
                    setShowEditModal(false);
                  }}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <AddSubmitButton form={form} isLoading={isLoading} />
              </Row>
            </Row>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Review Memo"
        centered
        open={showViewModal}
        footer={null}
        onCancel={() => {
          setShowViewModal(false);
          resetValues();
        }}
        width={800}
      >
        <Form
          className="mt-3 mx-3"
          form={form}
          name="editForm"
          layout="vertical"
        >
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                name="memo_date"
                label="Date Posted"
              >
                <DatePicker disabled/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item
                name="memo_from"
                label="Memo From"
                rules={[
                  {
                    required: true, whitespace: true,
                  },
                ]}
              >
                <Input disabled/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={24}>
              <Form.Item
                name="subject"
                label="Subject"
                rules={[
                  {
                    required: true, whitespace: true,
                  },
                ]}
              >
                <Input disabled/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={24}>
              <Form.Item
                name="content"
                label="Content"
                rules={[
                  {
                    required: true, whitespace: true,
                  },
                ]}
              >
               <ReactQuillEditor content={content} isDisabled={true}/>
              </Form.Item>
            </Col>
          </Row>
          <Row>
          <span className="red me-1">*</span> Recipients
            <Form.List
              name="recipients"
              initialValue={[{}]}
            >
              {(fields, { add, remove }) => (
                <>
                  <Col xs={24} lg={24}>
                    {fields.map(({ key, name, fieldKey }) => (
                        <Row
                          key={key}
                          style={{ marginBottom: 0 }}
                          className="d-flex justify-content-between"
                        >
                          <Col xs={12}>
                            <Form.Item
                              name={[name, "type"]}
                              fieldKey={[fieldKey, "type"]}
                              rules={[
                                {
                                  required: true, whitespace: true,
                                  message: "Please select the recipient type",
                                },
                              ]}
                            >
                              <Select placeholder="Type" disabled>
                                {/* <Option value="branch">Branch</Option> */}
                                {/* <Option value="business_unit">Business Unit</Option> */}
                                {/* <Option value="department">Department</Option> */}
                                <Option value="employment_status">Employment Status</Option>
                                <Option value="position">Position</Option>
                                <Option value="project">Project</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12}>
                            <Form.Item
                              name={[name, "memo_to"]}
                              fieldKey={[fieldKey, "memo_to"]}
                              rules={[
                                {
                                  required: true, whitespace: true,
                                  message: "Please select the memo to",
                                },
                              ]}
                            >
                              <Select disabled placeholder="Memo To" options={dropdownOptions[form.getFieldValue(["recipients", name, "type"])]}/>
                            </Form.Item>
                          </Col>
                          {/* <Col xs={4}>
                            <Button
                              onClick={() => {
                                remove(name);
                              }}
                              icon={<DeleteOutlined />}
                            />
                          </Col> */}
                        </Row>
                      ))}
                  </Col>
                </>
              )}
            </Form.List>
          </Row>

          <Form.Item>
            <Row className="d-flex justify-content-end mt-4">
              <Button
                danger
                onClick={() => setShowViewModal(false)}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                type="text"
                onClick={() => {
                  setShowViewModal(false);
                  // refreshPage();
                  setShowEditModal(true);
                }}
                icon={<EditOutlined />}
                disabled={clickedRowData.status==="approved"}
              >
                Edit
              </Button>
              {
                isAdminLogin &&
                <Button
                  type="text"
                  onClick={() => {
                    confirmApprove(clickedRowData)
                  }}
                  icon={<CheckCircleOutlined />}
                  disabled={clickedRowData.status==="approved"}
                >
                  Approve
                </Button>
              }
              <Button
                type="text"
                onClick={() => {
                  navigate("view", {state: clickedRowData})
                }}
                icon={<EyeOutlined />}
              >
                View
              </Button>
              <Button
                type="text"
                danger
                onClick={() => {
                  confirmDelete(clickedRowData);
                }}
                icon={<DeleteOutlined />}
              >
                Delete
              </Button>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
      {contextHolder}
    </Navbar>
  );
}
